import React from 'react';
import FieldTitle from 'components/form/field/field-title';

export default ({ field }) => <FieldTitle title={field.label} />;
